//标题组件
import LpTitle from './title'
//分页组件
import LpPagination from './pagination'
//tabs组件
import LpTabs from './tabs'
//无数据组件
import LpEmpty from './empty'
//面包屑组件
import LpBreadcrumb from './breadcrumb'
//机构数据列表
import lpList from './list'
//头部组件
import LpHeader from './header'
//底部组件
import LpFooter from './footer'
//最新资讯列表组件
import LpInformationList from './inforlist'
//政策解读列表组件
import LpPolicyList from './policylist'
//风采列表组件
import LpNewStyleList from './newstylelist'
//第三方机构列表
import LpThirdPartyList from './thirdpartylist'
//更多资讯列表
import LpMoreInforList from './moreinfor'
// 开发中组件
import LpDeveloping from './developing'
// 详情页组件
import LpDetail from './detail'
// 登录组件-弹窗-3种账号类型
import LpLogin from './login' 
// 政策申请组件
import LpPolicyApply from './policyapply'
// 政策评审组件
import LpPolicyReview from './policyreview'
// 政策申请-第三方机构列表组件
import LpPolicyApplyList from './policyapplylist'
// 政策咨询-组件
import LpPolicyConsult from './policyconsulting'
// 忘记密码-步骤组件
import lpStepsLine from './stepsline'
// 搜索
import LpHomeSearchList from './homesearchlist'

const initCgComponents = {
  // install 默认的方法
  install: function (Vue) {
    Vue.component('LpTitle', LpTitle);
    Vue.component('LpPagination', LpPagination);
    Vue.component('LpTabs', LpTabs);
    Vue.component('LpEmpty', LpEmpty);
    Vue.component('LpBreadcrumb', LpBreadcrumb);
    Vue.component('lpList', lpList);
    Vue.component('LpHeader',LpHeader);
    Vue.component('LpFooter',LpFooter);
    Vue.component('LpInformationList',LpInformationList);
    Vue.component('LpPolicyList',LpPolicyList);
    Vue.component('LpThirdPartyList',LpThirdPartyList);
    Vue.component('LpMoreInforList',LpMoreInforList);
    Vue.component('LpDeveloping',LpDeveloping);
    Vue.component('LpDetail', LpDetail);
    Vue.component('LpLogin', LpLogin);
    Vue.component('LpPolicyApply', LpPolicyApply);
    Vue.component('LpPolicyReview', LpPolicyReview);
    Vue.component('LpPolicyApplyList', LpPolicyApplyList);
    Vue.component('LpPolicyConsult', LpPolicyConsult);
    Vue.component('lpStepsLine', lpStepsLine);
    Vue.component('LpNewStyleList', LpNewStyleList);
    Vue.component('LpHomeSearchList', LpHomeSearchList);
  }
}
// 导出
export default initCgComponents




// WEBPACK FOOTER //
// ./src/components/index.js